"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentMasking = exports.processDataset = void 0;
function processDataset(data) {
    if (!data || (data && !data.behavior)) {
        return;
    }
    var _a = data.behavior || {}, v3 = _a.v3, v4 = _a.v4, rest = __rest(_a, ["v3", "v4"]);
    var result = __assign({}, rest);
    if (v4) {
        result = __assign(__assign({}, rest), v4);
    }
    return result;
}
exports.processDataset = processDataset;
function contentMasking(content) {
    return content ? content.replace(/./gm, "*") : "";
}
exports.contentMasking = contentMasking;
